unit f_utenticdiurnoepensionati;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery, w_table,
  w_edit, w_label, DB, un_user, un_servermodule;

type

  TVisibilita = (visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso);
const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo gli ultimi 300 prodotti' ;
  msgDateErrate = 'Correggi le date corrette per visualizzare gli prodotti';
  msgNessunRecord = 'Nessun record da visualizzare';
  msgCaricamentoInCorso = 'Caricamento record in corso...';

type
  { TFrmUtentiCDiurnoePensionati }

  TFrmUtentiCDiurnoePensionati = class(TWidget)
    procedure AfterRender; override;
  private
    whereDate :String;
    procedure ShowUtentiCDiurnoePensionati; async;
    procedure QryUtentiCDiurnoePensionatiOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita:TVisibilita);
    procedure CalcolaNumeroFruitori;  async;
  published
    procedure tab1_rowclick; async;
    procedure aprimaps; async;
    procedure filtro_change;
    procedure filtro_input;
    procedure lblHeader_click; async;
    procedure fldiurno_click; async;
    procedure flpensionati_click; async;
    procedure idpulmino_click; async;
    procedure idgiorno_click; async;
    procedure stampa_click(event: TJSEvent); async;
    stampa :TJSHTMLButtonElement;
    procedure stampa1_click(event: TJSEvent); async;
    stampa1 :TJSHTMLButtonElement;
    filtro: TWEdit;
    pnltab1: TJSHTMLElement;
    iddiurno : TJSHTMLInputElement;
    idpensionati : TJSHTMLInputElement;
    fldiurno : TJSHTMLInputElement;
    flpensionati : TJSHTMLInputElement;
    idpulmino : TJSHTMLInputElement;
    idnumero : TJSHTMLInputElement;
    idgiorno : TJSHTMLInputElement;
    QryCalcola: TQuery;
    QryUtentiCDiurnoePensionati: TQuery;
    tab1:TWTable;
    labelTop:TWLabel;
    labelBottom:TWLabel;
    pnlTabella:TJSHTMLElement;
  end;

implementation

{$R *.html}

{ TFrmUtentiCDiurnoePensionati }

procedure TFrmUtentiCDiurnoePensionati.AfterRender;
begin

  QryUtentiCDiurnoePensionati.OnFilterRecord := @QryUtentiCDiurnoePensionatiOnFilterRecord;

  filtro.placeholder := 'Ricerca utente...';
  filtro.seleziona1.Visible:= false;

  labelTop.header.innerHTML:= '<br><br>';
  labelTop.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 18px; font-weight: bold; border-style: solid;';
  labelTop.footer.innerHTML:= '<br><br>';

  labelBottom.labelbody.innerHTML:= 'bottom';
  labelBottom.header.innerHTML:= '<br>';
  labelBottom.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 22px; font-weight: bold; border-style: solid;';

  ShowUtentiCDiurnoePensionati;

  CalcolaNumeroFruitori;

end;

procedure TFrmUtentiCDiurnoePensionati.ShowUtentiCDiurnoePensionati; async;
var
  sSql: string;
  sNomeCampoGiorno: string;
  sDataOggi: string;
begin
  ImpostaVisibilita(visCaricamentoInCorso);

  sDataOggi := FormatDateTime('yyyy-mm-dd', Date);

  // 1. Determiniamo il nome del campo fisico nel DB in base al giorno scelto
  sNomeCampoGiorno := '';

  if (idgiorno.Value <> '') then
  begin
    case idgiorno.Value.ToInteger of
      1: sNomeCampoGiorno := 'fllunedi';
      2: sNomeCampoGiorno := 'flmartedi';
      3: sNomeCampoGiorno := 'flmercoledi';
      4: sNomeCampoGiorno := 'flgiovedi';
      5: sNomeCampoGiorno := 'flvenerdi';
    end;
  end;

  // 2. Costruzione Query
  sSql := 'SELECT dsragionesociale AS utente, '
        + 'dsindirizzo || '' - '' || dslocalita || '' - '' || dsprovincia AS indirizzo, '
        + 'dstelefono as telefono, frcdiurno AS diu, frasspensionati AS pens, '
        + 'fllunedi lun, flmartedi mar, flmercoledi mer, '
        + 'flgiovedi gio, flvenerdi ven, '
        + 'dstelefono || '' - '' || dsnote AS telnote '
        + 'FROM an_anagrafiche '
        + 'WHERE (frcdiurno IN (''X'') OR frasspensionati IN (''X'')) ';

  // Filtro Sospensione
  sSql := sSql
        + ' AND (DTSOSPESOFINOA IS NULL OR '
        + #39 + sDataOggi + #39 + ' > DTSOSPESOFINOA) ';

  // Filtri Checkbox (Diurno/Pensionati)
  if fldiurno.Checked then
    sSql := sSql + ' AND frcdiurno IN (''X'') ';

  if flpensionati.Checked then
    sSql := sSql + ' AND frasspensionati IN (''X'') ';

  // 3. FILTRO PULMINO
  //
  // Pulmino 1 -> valori 1a e 1b
  // Pulmino 2 -> valori 2a e 2b
  // Pulmini dal 3 in poi -> valore numerico originale
  //
  if (sNomeCampoGiorno <> '') and (idpulmino.Value <> '') then
  begin
    if idpulmino.Value.ToInteger = 1 then
    begin
      sSql := sSql
            + ' AND ' + sNomeCampoGiorno
            + ' IN (''1a'', ''1b'') ';
    end
    else if idpulmino.Value.ToInteger = 2 then
    begin
      sSql := sSql
            + ' AND ' + sNomeCampoGiorno
            + ' IN (''2a'', ''2b'') ';
    end
    else
    begin
      sSql := sSql
            + ' AND ' + sNomeCampoGiorno
            + ' = ' + QuotedStr(idpulmino.Value);
    end;
  end;

  // 4. Ordinamento secondo l'ordine impostato nell'anagrafica
  sSql := sSql + ' ORDER BY IDORDINE ASC';

  // 5. Esecuzione
  QryUtentiCDiurnoePensionati.Close;
  QryUtentiCDiurnoePensionati.SQL.Text := sSql;
  AWait(QryUtentiCDiurnoePensionati.Open);

  // 6. Aggiornamento Conteggio
  idnumero.Value := IntToStr(
    QryUtentiCDiurnoePensionati.RecordCount
  );

  // 7. Aggiornamento Interfaccia
  RefreshFiltro;
end;

procedure TFrmUtentiCDiurnoePensionati.QryUtentiCDiurnoePensionatiOnFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
var
  str:String;
  i: Integer;
begin
  Accept:= true;
  str := filtro.value.ToLowerInvariant;
  for i:= 0 to DataSet.FieldCount-1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
         exit;
  end;
  //nessun campo matcha la stringa cercata
  Accept := false;
end;

procedure TFrmUtentiCDiurnoePensionati.SetLabel(lbl:TWLabel;value:String);
begin

  lbl.Visible :=   value <> '' ;
  lbl.labelbody.innerHTML := value;

end;

procedure TFrmUtentiCDiurnoePensionati.ImpostaVisibilita(visibilita: TVisibilita);
begin

  //visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso
  SetLabel(labelTop,'');
  SetLabel(labelBottom,'');

  if visibilita = visDateErrate then SetLabel(labelTop,msgDateErrate);
  if visibilita = visNessunRecord then SetLabel(labelBottom,msgNessunRecord);
  if visibilita = visLimiteRecord then SetLabel(labelBottom,msgLimiteRecord);
  if visibilita = visCaricamentoInCorso then SetLabel(labelBottom,msgCaricamentoInCorso);

  filtro.Visible :=  visibilita <> visDateErrate;
//  console.log(format(' filtro.Visible := %s',[BoolToStr(filtro.Visible,true)]));
  pnltab1.Visible:= visibilita in [visLimiteRecord,visCiSonoRecord];

end;

procedure TFrmUtentiCDiurnoePensionati.CalcolaNumeroFruitori;
begin
   // calcolo il numero degli utenti c. diurno
  QryCalcola.Close;
  QryCalcola.SQL.Text:= ' select count(idanagrafica) as UtCDiurno from an_anagrafiche ';
  QryCalcola.SQL.Text := QryCalcola.SQL.Text + ' where (frcdiurno = ''X'') ';
  AWait(QryCalcola.Open);

  iddiurno.value := QryCalcola.FieldByName('UtCDiurno').AsString;

  // calcolo il numero dei pensionati ass.  pensionati
  QryCalcola.Close;
  QryCalcola.SQL.Text:= ' select count(idanagrafica) as UtAssPens from an_anagrafiche ';
  QryCalcola.SQL.Text := QryCalcola.SQL.Text + ' where (frasspensionati = ''X'') ';
  AWait(QryCalcola.Open);

  idpensionati.value := QryCalcola.FieldByName('UtAssPens').AsString;
end;

procedure TFrmUtentiCDiurnoePensionati.RefreshFiltro;
begin

  QryUtentiCDiurnoePensionati.Filtered:= filtro.value.Trim <> '';
  QryUtentiCDiurnoePensionati.First;
  tab1.RenderDataSet(QryUtentiCDiurnoePensionati);

  if QryUtentiCDiurnoePensionati.IsEmpty then
    ImpostaVisibilita(visNessunRecord)
  else if QryUtentiCDiurnoePensionati.RecordCount = limiteRecord  then
    ImpostaVisibilita(visLimiteRecord)
  else
    ImpostaVisibilita(visCiSonoRecord);

end;

procedure TFrmUtentiCDiurnoePensionati.filtro_change;
begin

  RefreshFiltro;

end;

procedure TFrmUtentiCDiurnoePensionati.filtro_input;
begin

  RefreshFiltro;

end;

procedure TFrmUtentiCDiurnoePensionati.lblHeader_click;
begin

  ShowUtentiCDiurnoePensionati;

end;

procedure TFrmUtentiCDiurnoePensionati.fldiurno_click;
begin
  flpensionati.checked:=false;
  ShowUtentiCDiurnoePensionati;
end;

procedure TFrmUtentiCDiurnoePensionati.flpensionati_click;
begin
  fldiurno.checked:=false;
  ShowUtentiCDiurnoePensionati;
end;

procedure TFrmUtentiCDiurnoePensionati.idpulmino_click;
begin
  ShowUtentiCDiurnoePensionati;
end;

procedure TFrmUtentiCDiurnoePensionati.idgiorno_click;
begin
  ShowUtentiCDiurnoePensionati;
end;

procedure TFrmUtentiCDiurnoePensionati.stampa_click(event: TJSEvent);
var
  sql, clausola: String;
begin

  with ServerModule('TWebStampe') do
  begin
    Params['idStampa'] := '134';
    AWait(Call('WebParametri'));
    sql := Response.Strings['SQL'];
  end;

  with ServerModule('TWebStampe') do
  begin
    Proc := 'WebProcessa';
    Params['idStampa'] := '134';
    Params['sql'] := sql;
    window.open(Url,'_blank');
  end;
end;

procedure TFrmUtentiCDiurnoePensionati.stampa1_click(event: TJSEvent);
var
  sql, clausola: String;
begin

  with ServerModule('TWebStampe') do
  begin
    Params['idStampa'] := '135';
    AWait(Call('WebParametri'));
    sql := Response.Strings['SQL'];
  end;

  with ServerModule('TWebStampe') do
  begin
    Proc := 'WebProcessa';
    Params['idStampa'] := '135';
    Params['sql'] := sql;
    window.open(Url,'_blank');
  end;
end;

procedure TFrmUtentiCDiurnoePensionati.aprimaps;
var
  Indirizzo, URL: string;
begin
  Indirizzo := Trim(QryUtentiCDiurnoePensionati.FieldByName('indirizzo').AsString);

  if Indirizzo = '' then
    Exit;

  URL := 'https://www.google.com/maps/search/?api=1&query=' +
         EncodeURIComponent(Indirizzo);

  asm
    window.open(URL, '_blank');
  end;
end;

procedure TFrmUtentiCDiurnoePensionati.tab1_rowclick;
var
  NumeroTelefono: string;
  Indirizzo: string;
  myself: TFrmUtentiCDiurnoePensionati;
  addr: Pointer;
begin
  if not QryUtentiCDiurnoePensionati.Active then Exit;
  if QryUtentiCDiurnoePensionati.IsEmpty then Exit;

  NumeroTelefono := Trim(QryUtentiCDiurnoePensionati.FieldByName('telefono').AsString);
  Indirizzo := Trim(QryUtentiCDiurnoePensionati.FieldByName('indirizzo').AsString);

  myself := Self;
  addr := Self.MethodAddress('aprimaps');

  asm
    var vecchio = document.getElementById('popupVolontario');
    if (vecchio) vecchio.remove();

    var popup = document.createElement('div');
    popup.id = 'popupVolontario';

    popup.style.cssText =
      'position:fixed; inset:0; background:rgba(0,0,0,0.65);' +
      'display:flex; align-items:center; justify-content:center;' +
      'z-index:99999; padding:20px;';

    var contenitore = document.createElement('div');

    contenitore.style.cssText =
      'background:white; width:100%; max-width:350px;' +
      'padding:25px; border-radius:16px; text-align:center;' +
      'box-shadow:0 5px 25px rgba(0,0,0,0.3);';

    contenitore.innerHTML =
      '<h2>Cosa vuoi fare?</h2>' +

      '<button id="btnAnnulla" style="width:100%;padding:17px;margin:8px 0;">Annullare</button>' +

      '<button id="btnTelefono" style="width:100%;padding:17px;margin:8px 0;">Telefonare</button>' +

      '<button id="btnMaps" style="width:100%;padding:17px;margin:8px 0;">Vedere la mappa</button>';

    popup.appendChild(contenitore);
    document.body.appendChild(popup);

    document.getElementById('btnAnnulla').onclick = function() {
      popup.remove();
    };

    document.getElementById('btnTelefono').onclick = function() {
      popup.remove();

      if (NumeroTelefono.trim() !== '') {
        window.location.href = 'tel:' + NumeroTelefono;
      } else {
        alert('Numero telefonico non presente.');
      }
    };

    document.getElementById('btnMaps').onclick = function() {

      if (Indirizzo.trim() === '') {
        alert('Indirizzo non presente.');
        return;
      }

      var cb = rtl.createCallback(myself, addr);
      cb();
      popup.remove();
    };
  end;
end;

initialization
  RegisterWeb(TFrmUtentiCDiurnoePensionati);

end.

